import React from "react";
import { Box } from "@mui/material";
import PatientForm from "../Components/Nurse/PatientForm";
import PatientReport from "../Components/Nurse/PatientReport";
import DrApot from "../Components/Nurse/DrApot";
import { Wrapper } from "../style/PatinetFormStyle";

const Nurse = () => {
  return (
    <Box
      sx={{
        ...Wrapper,
        // backgroundColor: "neutral.blueShadeBg",
        // height: "100vh",
        // marginTop: "5rem",
        // padding: "2rem 1rem",
      }}
    >
      <PatientForm />
      <PatientReport />
      <DrApot />
    </Box>
  );
};

export default Nurse;
